import BaseEntity from "@/core/misc/BaseEntity";
import PaymentTerm from "@/domains/PaymentTerms/PaymentTerm";
import  Core from "@/core/Core";

class AbstractContract extends BaseEntity {

    private paymentTerms: PaymentTerm[] = [];

    static fromServer(data: any, contract = new AbstractContract()): AbstractContract {
        super.fromServer(data, contract);

        contract.paymentTerms = Core.utils.hydrateArray(data.paymentTerms, PaymentTerm.fromServer) ?? [];

        return contract;
    }

    get postpaymentTerms() {
      return this.paymentTerms.filter((paymentTerm: PaymentTerm) => paymentTerm.event?.paymentType === 'post');
    }

    get prepaymentTerms() {
      return this.paymentTerms.filter((paymentTerm: PaymentTerm) => paymentTerm.event?.paymentType === 'pre');
    }
}

export default AbstractContract;
